import { render, staticRenderFns } from "./UsersAdmin.vue?vue&type=template&id=7e1961ca&"
import script from "./UsersAdmin.vue?vue&type=script&lang=js&"
export * from "./UsersAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports